import { i18n } from '@/shared/i18n';

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

/**
 * Renders a coarse "time ago" label for a comment timestamp ("just now",
 * "5m ago", "2d ago", …). Lives in the feature layer so the target-agnostic
 * CommentThread variants share one implementation.
 */
export function formatRelativeTime(dateStr: string): string {
  const diffSeconds = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);

  if (diffSeconds < MINUTE) return i18n.t('projects:commentOnFile.formatRelativeTime.justNow');
  if (diffSeconds < HOUR)
    return i18n.t('projects:commentOnFile.formatRelativeTime.minutesAgo', {
      minutes: Math.floor(diffSeconds / MINUTE),
    });
  if (diffSeconds < DAY)
    return i18n.t('projects:commentOnFile.formatRelativeTime.hoursAgo', {
      hours: Math.floor(diffSeconds / HOUR),
    });
  if (diffSeconds < WEEK)
    return i18n.t('projects:commentOnFile.formatRelativeTime.daysAgo', {
      days: Math.floor(diffSeconds / DAY),
    });
  if (diffSeconds < MONTH)
    return i18n.t('projects:commentOnFile.formatRelativeTime.weeksAgo', {
      weeks: Math.floor(diffSeconds / WEEK),
    });
  if (diffSeconds < YEAR)
    return i18n.t('projects:commentOnFile.formatRelativeTime.monthsAgo', {
      months: Math.floor(diffSeconds / MONTH),
    });
  return i18n.t('projects:commentOnFile.formatRelativeTime.yearsAgo', {
    years: Math.floor(diffSeconds / YEAR),
  });
}
